/**
 * getTopUser.js
 * Written by: Alex Kasemir
 */
import request from '../../../request/actions';

export const getTopUserStart = (id) => ({
  type: `GET_TOP_USER_START`,
  id,
});

export const getTopUserSuccess = (id, user) => ({
  type: `GET_TOP_USER_SUCCESS`,
  user,
  id,
});

export const getTopUserFailure = (error) => ({
  type: `GET_TOP_USER_FAILURE`,
  error,
});

/**
 * Description of the getTopUser action
 */
export const getTopUser = (id) => {
  return (dispatch) => {
    dispatch(getTopUserStart(id));
    return dispatch(request(`/quizzes/${id}/top_user`, `GET`))
      .then((response) => {
        dispatch(getTopUserSuccess(id, response.data));
      })
      .catch((error) => {
        dispatch(getTopUserFailure(error));
      });
  };
};

export default getTopUser;
